import { Badge, Box, Flex, Text } from '@chakra-ui/react'
import { EncounterType } from '@hb/shared'
import { LockIcon } from '../../../icons/LockIcon'
import { ProfileEncounterList } from '../../Encounters/EncountersList/ProfileEncountersList'
import { useLaborCharting } from './context'

export const PostpartumSection = () => {
  const { stage, setOpenExam } = useLaborCharting()
  const isActive = stage === 'postpartum'
  const isLocked = stage !== 'postpartum'

  return (
    <Box
      w="100%"
      bg="white"
      _dark={{ bg: 'gray.900' }}
      borderRadius={8}
      boxShadow="0 1px 4px #00000022"
      overflow="hidden"
      opacity={isLocked ? 0.7 : 1}>
      {/* Section header */}
      <Flex
        align="center"
        px={4}
        py={3}
        borderBottom="1px solid"
        borderColor={isActive ? 'green.200' : 'gray.100'}
        _dark={{
          borderColor: isActive ? 'green.600' : 'whiteAlpha.100',
          bg: isActive ? 'green.900' : 'gray.800',
        }}
        bg={isActive ? 'green.50' : 'gray.50'}>
        <Text
          fontFamily="Hero-New"
          fontWeight={700}
          fontSize="lg"
          color={isActive ? 'green.700' : 'gray.500'}
          _dark={{ color: isActive ? 'green.200' : 'gray.300' }}>
          POSTPARTUM
        </Text>
        {isActive && (
          <Badge ml={3} colorScheme="green" fontFamily="Hero-New" fontSize="xs">
            Active
          </Badge>
        )}
      </Flex>
      <Box>
        {isActive ? (
          <ProfileEncounterList type={EncounterType.POSTPARTUM} onOpenExam={setOpenExam} />
        ) : (
          <Flex align="center" gap={3} px={4} py={5} color="gray.400" _dark={{ color: 'gray.500' }}>
            <LockIcon />
            <Text fontFamily="Hero-New" fontSize="sm">
              Awaiting delivery — postpartum charting will unlock once delivery is logged.
            </Text>
          </Flex>
        )}
      </Box>
    </Box>
  )
}
